const moment = require('moment');

export const filterMoney = (amount, sign = ',') => {
  if (amount) {
    return amount
      .toString()
      .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, (
        all,
        pre,
        groupOf3Digital
      ) => pre + groupOf3Digital.replace(/\d{3}/g, `${sign }$&`));
  }
  return 0;
};

export const filterToday = (value) => {
  // 要回傳的結果
  let returnText = 'null';
  const time = value.split(' ')[1].substring(0, value.split(' ')[1].length - 3);

  // 判斷上午下午
  if (moment(value).format('A') === 'AM') {
    returnText = `上午 ${time}`;
  } else {
    returnText = `下午 ${time}`;
  }
  return returnText;
};

export const filterWeek = (value) => {
  // 要回傳的結果
  let returnText = 'null';
  switch (parseInt(moment(value).format('E'), 16)) {
    case 7:
      returnText = '日';
      break;
    case 6:
      returnText = '六';
      break;
    case 5:
      returnText = '五';
      break;
    case 4:
      returnText = '四';
      break;
    case 3:
      returnText = '三';
      break;
    case 2:
      returnText = '二';
      break;
    case 1:
      returnText = '一';
      break;
    default:
      break;
  }
  return `${moment(value).format('M/D')} (${returnText})`;
};

export const filterMonthDateAndTime = (value) => {
  // 要回傳的結果
  if (!value || !value.split(' ')[0] || !value.split(' ')[1]) {
    return '-';
  }
    return `${moment(value).format('M/D')} ${moment(value).format('HH:mm')}`;
};

export const filterText = (value) => {
  if (!value) return '';
  return value.replace(/\n/g, '<br>');
};

export const filterMonthToWord = (value) => {
  // 要回傳的結果
  if (!value) {
    return '-';
  }
  const month = parseInt(value);
  switch (month) {
    case 1:
    case '1':
    case '01':
      return '一月';
      break;
    case 2:
    case '2':
    case '02':
      return '二月';
      break;
    case 3:
    case '3':
    case '03':
      return '三月';
      break;
    case 4:
    case '4':
    case '04':
      return '四月';
      break;
    case 5:
    case '5':
    case '05':
      return '五月';
      break;
    case 6:
    case '6':
    case '06':
      return '六月';
      break;
    case 7:
    case '7':
    case '07':
      return '七月';
      break;
    case 8:
    case '8':
    case '08':
      return '八月';
      break;
    case 9:
    case '9':
    case '09':
      return '九月';
      break;
    case 10:
    case '10':
      return '十月';
      break;
    case 11:
    case '11':
      return '十一月';
      break;
    case 12:
    case '12':
      return '十二月';
      break;
    default:
      break;
  }
};
